import React, { createContext, useContext, useEffect, useState } from "react";

type PincodeContextType = {
  pincode: string | null;
  setPincode: (pin: string) => void;
};

const PincodeContext = createContext<PincodeContextType | null>(null);

export const PincodeProvider = ({ children }: { children: React.ReactNode }) => {
  const [pincode, setPincodeState] = useState<string | null>(null);

  useEffect(() => {
    const saved = localStorage.getItem("user_pincode");
    if (saved) setPincodeState(saved);
  }, []);

  const setPincode = (pin: string) => {
    setPincodeState(pin);
    localStorage.setItem("user_pincode", pin);
  };

  return (
    <PincodeContext.Provider value={{ pincode, setPincode }}>
      {children}
    </PincodeContext.Provider>
  );
};

export const usePincode = () => {
  const ctx = useContext(PincodeContext);
  if (!ctx) throw new Error("usePincode must be used inside PincodeProvider");
  return ctx;
};
